import { AdminUserCountsResponse } from "@authory-packages/core";
import * as React from "react";

type UserCountsContextProps = {
  children: JSX.Element;
};

export interface CountsHooks {
  counts: AdminUserCountsResponse | null;
  setCounts: (user: AdminUserCountsResponse | null) => void;
}

export const CountsContext = React.createContext<CountsHooks>({
  counts: null,
  setCounts: () => {},
});

export const UserCountsContext = ({ children }: UserCountsContextProps) => {
  const [counts, setCounts] = React.useState<AdminUserCountsResponse | null>(
    null
  );

  return (
    <CountsContext.Provider value={{ counts, setCounts }}>
      {children}
    </CountsContext.Provider>
  );
};
